/**
 * MyPagesMenuDropdown
 * @module components/MyPagesMenuDropdown
 */

import React, { useState, useContext } from 'react';
import { LocalizationContext } from 'context/localization.context';

import clsx from 'clsx';
import { LinkModel } from 'types';
import Icon from 'components/ui/Icon';

interface Props {
	myPagesLink: LinkModel;
	logoutLink: string;
}

const MyPagesMenuDropdown: React.FC<Props> = ({ myPagesLink, logoutLink }) => {
	const { t }: any = useContext(LocalizationContext);
	const [myPagesDropdownOpen, setMyPagesDropdownOpen] = useState(false);

	return (
		<div
			className="relative"
			onMouseLeave={(e) => {
				setMyPagesDropdownOpen(false);
			}}
			onMouseEnter={(e) => {
				setMyPagesDropdownOpen(true);
			}}
		>
			<a
				className={clsx(
					'relative inline-flex items-center font-semibold text-p py-1.5 px-4 mr-4 ml-auto whitespace-no-wrap border h-auto border-black rounded-full',
					'hover:underline '
				)}
				href={myPagesLink?.link}
				onKeyDown={(e: any) => {
					if (e.keyCode === 13) {
						e.preventDefault();
						if (myPagesDropdownOpen && window && window.location) {
							window.location.href = myPagesLink?.link;
						} else {
							setMyPagesDropdownOpen(true);
						}
					}
				}}
				onClick={(e: any) => {
					if (window.Modernizr && window.Modernizr.touchevents) {
						if (
							!myPagesDropdownOpen ||
							(myPagesDropdownOpen && e.target.tagName !== 'A')
						) {
							e.preventDefault();
						}
						setMyPagesDropdownOpen(true);
					}
				}}
			>
				<Icon icon="user" color="black" size={1} className="mr-2" />
				{myPagesLink?.text}
			</a>
			{logoutLink && (
				<div
					className={clsx(
						'my-page-dropdown absolute w-full bg-white border rounded-xl shadow border-white z-300',
						myPagesDropdownOpen ? 'h-auto visible' : 'hidden h-0'
					)}
				>
					<ul className="px-4 py-2">
						<li>
							<a
								href={logoutLink}
								className="text-p block text-black w-full m-0 p-0 hover:underline"
							>
								{t('shared/header/logout')}
							</a>
						</li>
					</ul>
				</div>
			)}
		</div>
	);
};

export default MyPagesMenuDropdown;
